"use strict";

// Header scroll
(() => {
  const header = document.querySelector("header.header");
  if (!header) return;

  const SHOW_AT = 300; // після цього px можемо показувати
  const HIDE_BELOW = 280; // нижче цього px точно ховаємо (гістерезис)
  const DELTA = 4; // ігноруємо мікрорухи 1–3px

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;

  const onScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const diff = scrollTop - lastScrollTop;

    // 1) Завжди ховаємо, якщо реально близько до верху сторінки
    if (scrollTop < HIDE_BELOW) {
      header.classList.remove("header-scroll");
      lastScrollTop = scrollTop;
      ticking = false;
      return;
    }

    // 2) Після SHOW_AT працюємо по напряму скролу, але лише якщо рух суттєвий
    if (scrollTop >= SHOW_AT && Math.abs(diff) >= DELTA) {
      if (diff > 0) {
        header.classList.add("header-scroll"); // скрол вниз
      } else {
        header.classList.remove("header-scroll"); // скрол вгору
      }
    }

    lastScrollTop = scrollTop;
    ticking = false;
  };

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true },
  );
})();

// Progressbar Scroll
(() => {
  if (window.innerWidth >= 1024) return;
  if (typeof siteSettings !== "undefined" && siteSettings.isFrontPage) return;

  document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("header.header");
    if (!header) return;

    const progressBarContainer = document.createElement("div");
    progressBarContainer.id = "progress-container";
    progressBarContainer.style.display = "none";

    const progressBar = document.createElement("div");
    progressBar.id = "progress-bar";

    progressBarContainer.appendChild(progressBar);
    header.appendChild(progressBarContainer);

    const updateProgress = () => {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      const docHeight =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;

      progressBarContainer.style.display = scrollTop > 0 ? "block" : "none";

      if (docHeight <= 0) return;

      const progress = (scrollTop / docHeight) * 100;
      progressBar.style.width = progress + "%";
    };

    window.addEventListener("scroll", updateProgress, { passive: true });
  });
})();

// Animate Scroll
(() => {
  const header = document.querySelector("header");
  const getHeaderHeight = () => (header ? header.offsetHeight : 0);

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const id = link.getAttribute("href");
    if (!id || id === "#") return;

    const target = document.querySelector(id);
    if (!target) return;

    e.preventDefault();

    const targetTop =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      getHeaderHeight();

    window.scrollTo({
      top: targetTop,
      behavior: "smooth",
    });
  });
})();

// Mobile Nav Toggle
(() => {
  const body = document.body;
  const burger = document.querySelector("button.burger");
  const nav = document.querySelector(".header-nav");

  if (!burger || !nav) return;

  burger.addEventListener("click", () => {
    body.classList.toggle("overflow-hidden");
    nav.classList.toggle("active");
    burger.classList.toggle("burger-active");
  });
})();

// Mobile SubNav open
(() => {
  const header = document.querySelector(".header");
  if (!header) return;

  const items = header.querySelectorAll(
    ".menu .swimming-pool-menu-item"
  );
  if (!items.length) return;

  items.forEach((item) => {
    const submenu = item.lastElementChild;
    if (!submenu) return;

    item.addEventListener("click", () => {
      const isMobile = window.innerWidth < 1024;

      if (!isMobile) {
        item.classList.toggle("open");
        return;
      }

      item.classList.toggle("open");

      if (submenu.style.maxHeight && submenu.style.maxHeight !== "0px") {
        // закриття
        submenu.style.maxHeight = "0";
        submenu.style.marginTop = "0";
        submenu.style.opacity = "0";
        submenu.style.marginBottom = "0";
      } else {
        // відкриття
        submenu.style.marginTop = "10px";
        submenu.style.marginBottom = "10px";
        submenu.style.opacity = "1";
        submenu.style.maxHeight = submenu.scrollHeight + "px";
      }
    });
  });
})();

// Social Share
(() => {
  const socialSpans = document.querySelectorAll(".social-share span");

  if (!socialSpans.length) return;

  socialSpans.forEach((span) => {
    span.addEventListener("click", () => {
      const link = span.dataset.link;
      const url = span.dataset.url;

      if (!link || !url) return;

      const fullUrl = "https://" + link + url;
      window.open(fullUrl, "_blank");
    });
  });
})();

document.querySelectorAll(".select select").forEach((select) => {
  if (select.selectedIndex === 0) {
    select.classList.remove("selected");
  }
  select.addEventListener("change", function () {
    this.classList.toggle("selected", this.selectedIndex > 0);
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const popupWrap = document.querySelector(".popup-wrap");
  const promoBar = document.querySelector(".promo-bar");

  if (!popupWrap || !promoBar) return;

  const SCROLL_THRESHOLD = 600;

  const handleScroll = () => {
    if (popupWrap.style.display === "flex") return;

    const scrollY = window.scrollY;

    if (scrollY > SCROLL_THRESHOLD) {
      promoBar.classList.add("active");
    } else {
      promoBar.classList.remove("active");
    }
  };

  window.addEventListener("scroll", handleScroll);

  document.addEventListener("click", (e) => {
    if (e.target.closest(".show-popup-form")) {
      e.preventDefault();
      popupWrap.style.display = "flex";
      promoBar.classList.remove("active");
    }

    if (e.target.closest(".close-popup")) {
      popupWrap.style.display = "none";
      handleScroll();
    }

    if (e.target === popupWrap) {
      popupWrap.style.display = "none";
      handleScroll();
    }
  });
});

(function () {
  const scroll = document.querySelector(".table-scroll");
  const thumb = document.querySelector(".scrollbar-thumb");
  const track = document.querySelector(".scrollbar");

  // 🔒 Якщо хоча б одного елемента немає — нічого не робимо
  if (!scroll || !thumb || !track) return;

  function updateScrollbar() {
    const scrollWidth = scroll.scrollWidth;
    const visibleWidth = scroll.clientWidth;

    if (scrollWidth > visibleWidth) {
      track.style.display = "block";
    } else {
      track.style.display = "none";
      return;
    }

    const thumbWidth = (visibleWidth / scrollWidth) * track.clientWidth;
    thumb.style.width = thumbWidth + "px";

    const scrollRatio = scroll.scrollLeft / (scrollWidth - visibleWidth);
    const maxMove = track.clientWidth - thumbWidth;

    thumb.style.transform = `translateX(${scrollRatio * maxMove}px)`;
  }

  window.addEventListener("load", updateScrollbar);
  window.addEventListener("resize", updateScrollbar);
  scroll.addEventListener("scroll", updateScrollbar);
})();